/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelPackageReasonAdminDto } from '../models/CancelPackageReasonAdminDto';
import type { CancelPackageReasonAdminListedDtoAdmin } from '../models/CancelPackageReasonAdminListedDtoAdmin';
import type { GetCancelPackageReasonsAdminOptions } from '../models/GetCancelPackageReasonsAdminOptions';
import type { PostPutCancelPackageReasonRequestAdmin } from '../models/PostPutCancelPackageReasonRequestAdmin';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CancelPackageReasonsService {
    /**
     * **Required Policy:** `ViewCancelPackageReasons`
     * @returns CancelPackageReasonAdminDto OK
     * @throws ApiError
     */
    public static getCancelPackageReasonByIdAdmin({
        id,
    }: {
        id: number,
    }): CancelablePromise<CancelPackageReasonAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/cancelpackagereasons/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageCancelPackageReasons`
     * @returns CancelPackageReasonAdminDto OK
     * @throws ApiError
     */
    public static putCancelPackageReasonAdmin({
        id,
        requestBody,
    }: {
        id: number,
        requestBody?: PostPutCancelPackageReasonRequestAdmin,
    }): CancelablePromise<CancelPackageReasonAdminDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/cancelpackagereasons/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `DeleteCancelPackageReasons`
     * @returns any OK
     * @throws ApiError
     */
    public static deleteCancelPackageReasonAdmin({
        id,
    }: {
        id: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/admin/v1/cancelpackagereasons/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewCancelPackageReasons`
     * @returns CancelPackageReasonAdminListedDtoAdmin OK
     * @throws ApiError
     */
    public static getCancelPackageReasonsAdmin({
        options,
    }: {
        options?: GetCancelPackageReasonsAdminOptions,
    }): CancelablePromise<Array<CancelPackageReasonAdminListedDtoAdmin>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/cancelpackagereasons',
            query: {
                'options': options,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageCancelPackageReasons`
     * @returns CancelPackageReasonAdminDto Created
     * @throws ApiError
     */
    public static postCancelPackageReasonAdmin({
        requestBody,
    }: {
        requestBody?: PostPutCancelPackageReasonRequestAdmin,
    }): CancelablePromise<CancelPackageReasonAdminDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/cancelpackagereasons',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
